module.exports = __webpack_public_path__ + "static/img/19-0919.ee4a6e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/19-0919.jpg
// module id = OQ/+
// module chunks = 0